export const MAINTENANCE_WARNINGS_DETAILS_OPEN_MODAL = "MAINTENANCE_WARNINGS_DETAILS_OPEN_MODAL";
export const MAINTENANCE_WARNINGS_DETAILS_REQUEST = "MAINTENANCE_WARNINGS_DETAILS_REQUEST";
export const MAINTENANCE_WARNINGS_DETAILS_RESULT = "MAINTENANCE_WARNINGS_DETAILS_RESULT";